export default "__VITE_ASSET__810ad840__"